import { Amplify } from 'aws-amplify';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import { defaultStorage } from 'aws-amplify/utils';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.REACT_APP_COGNITO_USER_POOL_ID,
      // Renamed from v5's `userPoolWebClientId`.
      userPoolClientId: import.meta.env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
      // `region` and `mandatorySignIn` have no v6 equivalent — dropped.
    },
  },
});

// You can set refresh token expiry in Cognito pool settings -> App Clients.
// `defaultStorage` is v6's localStorage-backed token store (same effective
// storage as v5's explicit `storage: window.localStorage`).
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage);
